import React, { useState } from "react";
import classes from "./dashboardlocation.module.css";
import { Typography, Button, Box, Avatar } from "@mui/material";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import MyTableBody from "../../../components/LocationListView";
import { getLanguagedataFunction } from "../../../utilities/language";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SaveViewAll } from "../../../Redux/actions/location-action";
import DashboardLocationCard from "./DashboardLocationCard";

const DashBoardBoxContainer = ({
  locationList,
  viewAll,
  fromDate,
  toDate,
  setUpdateState,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("grid");
  const ln = useSelector((state) => state.allUsers.language_json);
  // const { locationList, locationFilteredStatus, locationFilterTime, locationFilterMembers, viewAll } =
  //   useSelector((state) => state.location);

  React.useEffect(() => {
    if (!ln) {
      getLanguagedataFunction(dispatch);
    }
  }, [dispatch, ln]);

  const handleViewAll = (e) => {
    e.stopPropagation();
    navigate("/location");
    dispatch(SaveViewAll(true));
  };

  const handleCardClick = (e, item) => {
    const name = item.slug.toLowerCase();
    navigate(`/location/${name}`);
    e.preventDefault();
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <div>
      {ln ? (
        <div>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>
                {ln.recent_locations} ({locationList?.length})
              </Typography>
              {/* <div className={classes.viewbittonContainer}>
                <Button
                  className={`${classes.button} ${
                    activeButton === "grid" ? `${classes.active}` : ""
                  }`}
                  onClick={() => handleButtonClick("grid")}
                >
                  <BsFillGrid3X3GapFill />
                </Button>
                <Button
                  className={`${classes.button} ${
                    activeButton === "list" ? `${classes.active}` : ""
                  }`}
                  onClick={() => handleButtonClick("list")}
                >
                  <FaList />
                </Button>
              </div> */}
            </div>
            <div>
              {window.location.pathname === "/home" && (
                <Button
                  variant="text"
                  style={{ textTransform: "none" }}
                  onClick={(e) => handleViewAll(e)}
                >
                  {viewAll ? ln.viewless : ln.viewall}
                </Button>
              )}
            </div>
          </Box>
          {activeButton === "grid" ? (
            <div>
              <div className={classes.GridContainer}>
                {locationList && locationList?.length > 0
                  ? locationList.map((item, index) => {
                      // const isOnline = findOnline(item.teamMember[0]._id);
                      // console.log(isOnline);
                      return (
                        <DashboardLocationCard
                          key={index}
                          item={item}
                          index={index}
                          handleCardClick={handleCardClick}
                          ln={ln}
                          fromDate={fromDate}
                          toDate={toDate}
                          setUpdateState={setUpdateState}
                        />
                      );
                    })
                  : (
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      py: 4,
                      width: '100%',
                      gridColumn: '1 / -1'
                    }}>
                      <Avatar sx={{ bgcolor: 'hsl(217, 91%, 95%)', color: 'hsl(217, 91%, 60%)', mb: 2, width: 56, height: 56 }}>
                        <BsFillGrid3X3GapFill size={28} />
                      </Avatar>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                        No Recent Tasks
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Recent check-ins will appear here.
                      </Typography>
                    </Box>
                  )}
              </div>
            </div>
          ) : (
            <div>
              <MyTableBody
                list={locationList}
                handleCardClick={handleCardClick}
              />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default DashBoardBoxContainer;
